import React from 'react';

import PropTypes from 'prop-types';
import { Delete } from '@tds/core-interactive-icon';

import { Td } from '../../ratePlans/components/css';

const SubscriberListRow = ({
  isCorporate,
  row,
  rowIndex,
  renewalSubscriberList,
  setRenewalSubscriberList
}) => {
  const {
    subscriber,
    plan,
    device,
    term,
    price,
    offer,
    vin,
    make,
    model,
    year
  } = row;

  const removeSubscriber = () => {
    const subscriberListCopy = [...renewalSubscriberList];
    subscriberListCopy.splice(rowIndex, 1);
    setRenewalSubscriberList(subscriberListCopy);
  };

  return (
    <tr>
      <Td>{rowIndex + 1}</Td>
      <Td>{subscriber}</Td>
      <Td>{plan}</Td>
      <Td>{device}</Td>
      <Td>{term}</Td>
      {!isCorporate && <Td>{price}</Td>}
      <Td>{offer}</Td>
      <Td style={{ background: !vin ? '#f4f4f4' : '#ffffff' }}>{vin}</Td>
      <Td style={{ background: !make ? '#f4f4f4' : '#ffffff' }}>{make}</Td>
      <Td style={{ background: !model ? '#f4f4f4' : '#ffffff' }}>{model}</Td>
      <Td style={{ background: !year ? '#f4f4f4' : '#ffffff' }}>{year}</Td>
      <Td>
        <div style={{ cursor: 'pointer' }}>
          <Delete onClick={removeSubscriber} a11yText="Delete" />
        </div>
      </Td>
    </tr>
  );
};

SubscriberListRow.propTypes = {
  row: PropTypes.shape({
    subscriber: PropTypes.string,
    plan: PropTypes.string,
    device: PropTypes.string,
    term: PropTypes.string,
    price: PropTypes.number,
    offer: PropTypes.string,
    vin: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.number,
    quantity: PropTypes.number
  }).isRequired,
  isCorporate: PropTypes.bool.isRequired,
  rowIndex: PropTypes.number.isRequired,
  renewalSubscriberList: PropTypes.arrayOf(PropTypes.object).isRequired,
  setRenewalSubscriberList: PropTypes.func.isRequired
};

export default SubscriberListRow;
